import i18n from "@/i18n";
import { getTick, postTick } from "@services/alert/tick";
import common from "@assets/js/common";
import dayjs from "dayjs";

const state = {
    autoRefreshTimeOffset: 30,
    loading: false,
    alertData: [],
    alertHeader: [
        {
            text: i18n.t("common.table.server"),
            value: "server_name",
            align: "left",
        },
        { text: i18n.t("common.table.symbol"), value: "symbol", align: "left" },
        {
            text: i18n.t("common.table.security"),
            value: "security",
            align: "left",
        },
        {
            text: i18n.t("common.table.secondsThreshold"),
            value: "seconds_threshold",
            align: "right",
        },
        {
            text: i18n.t("common.table.gap"),
            value: "gap",
            align: "right",
        },
        {
            text: i18n.t("common.table.action"),
            value: "action",
            align: "left",
        },
        {
            text: i18n.t("common.table.lastUpdateTime"),
            value: "last_update_time",
            width: 170,
            align: "left",
        },
        {
            text: i18n.t("common.table.triggerTime"),
            value: "current_time",
            width: 170,
            align: "left",
        },
    ],
    alertDataAmount: 0,
    csvHeader: {
        Server: "server_name",
        Symbol: "symbol",
        Security: "security",
        Threshold: "seconds_threshold",
        Gap: "gap",
        "Last Update Time": "last_update_time",
        "Trigger Time": "current_time",
    },
};

const actions = {
    getTickAction({ commit }, params) {
        commit("UPDATE_LOADING", true);
        getTick(params).then((res) => {
            res.data.data.map((item) => (item.loading = false));
            commit("UPDATE_ALERT_DATA", res.data.data);
            commit("UPDATE_AMOUNT", res.data.count);
            commit("UPDATE_LOADING", false);
        });
    },
    processTick({ commit }, data) {
        const minimumAcceptableTime = dayjs(
            common.getMT4Time().format("YYYY-MM-DD")
        ).unix();
        if (data.current_time >= minimumAcceptableTime) {
            const exist = state.alertData.find(
                (item) =>
                    item.server_name == data.server_name &&
                    item.symbol == data.symbol &&
                    item.security == data.security
            );
            if (!exist) {
                data["new"] = true;
                commit("UPDATE_ALERT_DATA", [data, ...state.alertData]);
            }
        }
    },
    updateSymbolAction(_, params) {
        return postTick(params);
    },
};

const mutations = {
    /**
     * Update loading
     * @param   {[type]}  state  [state description]
     * @param   {[type]}  data   [data description]
     * @return  {[type]}         [return description]
     */
    UPDATE_LOADING(state, data) {
        state.loading = data;
    },
    UPDATE_ALERT_DATA(state, data) {
        state.alertData = data;
    },
    UPDATE_ALERT_HEADER(state, data) {
        state.alertHeader = data;
    },
    UPDATE_AMOUNT(state, data) {
        state.alertDataAmount = data;
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
};
